export const tokens = {
  colors: {
    primary: '#DC2626',
    primaryHover: '#B91C1C',
    primaryFocus: 'rgba(220, 38, 38, 0.5)',
    bgDark: '#111827',
    bgCardDark: '#1F2937',
    bgLight: '#F9FAFB',
    bgWhite: '#FFFFFF',
    textDark: '#FFFFFF',
    textLight: '#1F2937',
    textBody: '#374151',
    textMuted: '#6B7280',
    textMutedDark: '#9CA3AF',
    border: '#E5E7EB',
    borderInput: '#D1D5DB',
    borderDark: '#374151',
    success: '#22C55E',
    warning: '#EAB308',
    error: '#DC2626',
    info: '#3B82F6',
  },
  font: {
    sans: '"Inter", system-ui, -apple-system, sans-serif',
  },
  radius: {
    button: '0.25rem',
    card: '0.5rem',
    input: '0.5rem',
    badge: '9999px',
  },
  logo: {
    dark: 'https://www.quartup.com/img/quartup-logo-wt.png',
    light: 'https://www.quartup.com/img/quartup-logo.png',
  },
} as const;
